<template>
    <div class="login__body">
        <div class="l-side flex xs12 sm12 md6 lg5 xl5">
            <div class="form-l">
                <div class="form-l__inner">
                    <div class="form-l__title">
                        <h4 class="title-h4">
                            Multitraining
                            Login
                        </h4>
                    </div>
                    <div class="form-l__body">
                        <form class="form" @submit.prevent="submitHandler">
                            <div class="form__row">
                                <div class="form__row-title ">
                                    {{ $t("form.email") }}
                                </div>
                                <div class="form__row-field">
                                    <textField
                                            v-model.trim="clientLogin.email"
                                            :v="$v.clientLogin.email"
                                            :placeholder="$t('form.email')"
                                            type="text"
                                            :theme="actualWidth >= 600 ? 'light' : 'dark'"
                                    />
                                </div>
                            </div>
                            <div class="form__row">
                                <div class="form__row-title ">
                                    {{ $t("form.password") }}
                                </div>
                                <div class="form__row-field">
                                    <textField
                                            v-model.trim="clientLogin.password"
                                            :v="$v.clientLogin.password"
                                            :placeholder="$t('form.password_placeholder')"
                                            type="password"
                                            :theme="actualWidth >= 600 ? 'light' : 'dark'"
                                    />
                                </div>
                            </div>
                            <div class="form__action">
                                <button type="submit" class="btn btn-w100 btn-gradient">
                                    <span> {{ $t("form.login") }}</span>
                                </button>
                            </div>
                        </form>
                    </div>
                    <div class="form-l__footer">
                        <p>
                                            <span>
                                                {{ $t("members.login.form.auth") }}
                                            </span>
                            <router-link to="/" class="form-l__link">{{ $t("members.login.form.more") }}</router-link></p>

                        <div class="form-l__action">
                            <router-link class="form-l__link" to="/members/reset-password">{{ $t("form.forgot_password") }}</router-link>
                            <!--<span>/</span>-->
                            <!--<router-link class="form-l__link" to="/">{{ $t("form.change_password") }}</router-link>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="r-side flex xs12 sm12 md5 lg6 xl6">
            <h2 class="login__title title-h2 ">
                {{ $t("members.login.title") }}
            </h2>
            <div class="login__subtitle">
                {{ $t("members.login.subtitle") }}
            </div>
        </div>
    </div>
</template>


<script>
    import textField from "@/elements/textField";
    import validate from "@/mixins/validate";
    // import StudioFooter from "../../studios/StudioFooter";
    import resize from "@/mixins/resize";

    export default {
        mixins: [validate, resize],
        components: {
            textField,
            // StudioFooter,
        },
        data() {
            return {
                clientLogin: {
                    email: '',
                    password: ''
                }
            }
        },
        methods: {
            async submitHandler() {
                this.$v.clientLogin.$touch();
                if (!this.$v.clientLogin.$invalid) {
                    let {email, password} = this.clientLogin;
                    let data = await this.$store.dispatch('CLIENT_MAKE_AUTH', {email: email, password: password})
                    if(data) this.$router.push('/members/dashboard')
                }
            },
        }
    }
</script>

<style lang="sass" scoped>
    .login
        &__body
            flex-wrap: wrap
            display: flex
            justify-content: space-between
            align-items: center
            flex: 1 1 auto
            height: calc(100% - 40px)

            +r(599)
                align-items: normal
        &__title
            +extra
            letter-spacing: 3px
            +r(1263)
                font-size: 29px
                line-height: 50px
        &__subtitle
            font-size: 18px
            margin-top: 16px
            letter-spacing: 1px
            +reg


    .form-l
        .form-l__footer
            span:first-child
                color: #1A3056

        +r(599)
            background-color: transparent
            box-shadow: none
            .form__row-title
                color: $color--white

            .form-l__footer
                span:first-child
                    color: $color--white

        &__title
            margin-bottom: 15px
            max-width: 270px
            margin: 0 auto

            +r(767)
                margin: 0
                .title-h4
                    font-size: 24px
                    line-height: 28px

            +r(599)
                color: $color--white


                .title-h4
                    text-align: left


        +r(1023)
            margin: 0 auto


    .r-side
        +r(959)
            display: none

</style>